import { HttpErrorResponse } from '@angular/common/http';
import { Sort } from '@angular/material/sort';
import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { Module } from 'app/library/module/models/module.model';

export class SetAllModules {
    static readonly type = '[AllModules] SetAllModules';

    constructor(public payload: Module[]) {}
}

export class UnsetAllModules {
    static readonly type = '[AllModules] UnsetAllModules';
}

export class FetchAllModules {
    static readonly type = '[AllModules] FetchAllModules';

    constructor(
        public payload?: {
            filterValues: { [key: string]: string[] };
            search: string;
            sortBy: string;
            sortOrder: string;
            pageSize: number;
            pageNumber: number;
            patchState?: boolean;
            kind?: string;
            ids?: string;
            context?: string;
        }
    ) {}
}

export class FetchAllModulesSuccess {
    static readonly type = '[AllModules] FetchAllModulesSuccess';

    constructor(public payload: Module[]) {}
}

export class FetchAllModulesFailure {
    static readonly type = '[AllModules] FetchAllModulesFailure';
}

export class FetchAllExecutions {
    static readonly type = '[AllModules] FetchAllExecutions';

    constructor(
        public payload: {
            search?: string;
            pageSize?: number;
            pageNumber?: number;
            sortBy?: string;
            sortOrder?: string;
            statusesIds?: string[];
            tags?: string[];
            types?: string[];
            extendedAttributesFilters: ExtendedAttributeFilterInterface[];
            executionDate?: ExtendedAttributeFilterInterface;
            columns: string[];
        }
    ) {}
}

export class FetchAllExecutionsSuccess {
    static readonly type = '[AllModules] FetchAllExecutionsSuccess';

    constructor(public payload: Module[]) {}
}

export class FetchAllExecutionsFailure {
    static readonly type = '[AllModules] FetchAllExecutionsFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[AllModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[AllModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[AllModules] DeselectSelectedModules';
}

export class SearchAllModules {
    static readonly type = '[AllModules] SearchAllModules';

    constructor(
        public payload: {
            searchItem: string;
            sessionStorageKey: string;
        }
    ) {}
}

export class SortAllModules {
    static readonly type = '[AllModules] SortAllModules';

    constructor(public payload: Sort) {}
}

export class SortAllExecutions {
    static readonly type = '[AllModules] SortAllExecutions';

    constructor(public payload: Sort) {}
}

export class FetchIncludedModules {
    static readonly type = '[AllModules] FetchIncludedModules';

    constructor(
        public payload: {
            reportId: string;
            startDate: string;
            endDate: string;
            pageSize: number;
            pageNumber: number;
        }
    ) {}
}

export class FetchIncludedModulesSuccess {
    static readonly type = '[AllModules] FetchIncludedModulesSuccess';

    constructor(public payload: Module[]) {}
}

export class FetchIncludedModulesFailure {
    static readonly type = '[AllModules] FetchIncludedModulesFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}
